import { api } from './client';

export type FunnelType = 'pwa' | 'referral';

export interface FunnelStep {
  name: string;
  value: number;
}

export interface FunnelDailyRow {
  date: string;
  impressions: number;
  clicks: number;
  completes: number;
  // PWA fields
  pwa_visits?: number;
  install_clicks?: number;
  installs?: number;
  pwa_opens?: number;
  // Referral fields
  referrals?: number;
  delivered?: number;
  // Common
  registrations: number;
  deposits: number;
  revenue_cents: number;
}

export interface FunnelData {
  funnel_type: FunnelType;
  steps: FunnelStep[];
  revenue_cents: number;
  daily: FunnelDailyRow[];
}

export interface FunnelFilters {
  start_date?: string;
  end_date?: string;
  campaign_id?: string;
  ad_id?: string;
  app_id?: string;
  country?: string;
  platform?: string;
  funnel_type?: FunnelType;
}

function buildQuery(filters: FunnelFilters): string {
  const params: string[] = [];
  if (filters.start_date) params.push(`start_date=${encodeURIComponent(filters.start_date)}`);
  if (filters.end_date) params.push(`end_date=${encodeURIComponent(filters.end_date)}`);
  if (filters.campaign_id) params.push(`campaign_id=${encodeURIComponent(filters.campaign_id)}`);
  if (filters.ad_id) params.push(`ad_id=${encodeURIComponent(filters.ad_id)}`);
  if (filters.app_id) params.push(`app_id=${encodeURIComponent(filters.app_id)}`);
  if (filters.country) params.push(`country=${encodeURIComponent(filters.country)}`);
  if (filters.platform) params.push(`platform=${encodeURIComponent(filters.platform)}`);
  if (filters.funnel_type) params.push(`funnel_type=${encodeURIComponent(filters.funnel_type)}`);
  return params.length > 0 ? '?' + params.join('&') : '';
}

export async function getFunnelData(filters: FunnelFilters = {}): Promise<FunnelData> {
  const query = buildQuery(filters);
  return api.get<FunnelData>(`/admin/stats/funnel${query}`);
}
